export default {
  bind(el, binding) {
    el.toggleClass = (event) => {
      event.preventDefault();
      const target = event.target.closest(`.${binding.arg}`);
      target && target.classList.add(binding.value);
      el.classList.add('active');
    };

    el.addEventListener('click', el.toggleClass);
  },

  unbind(el) {
    el.removeEventListener('click', el.toggleClass);
  },
};



// WEBPACK FOOTER //
// ./templates/floor/assets/js/VueApplication/Directives/setClassDirective.js